const initialState = {
  list: [],
  loading: false,
  error: null
}

const popupFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case "POPUP_FORM_LOADING":
      return { ...state, loading: true, error: null }
    case "GET_ALL_POPUP_FORMS": {
      const payload = action.data
      const normalized =
        (Array.isArray(payload?.data?.popupFormConfigData) && payload.data.popupFormConfigData) ||
        (Array.isArray(payload?.data?.items) && payload.data.items) ||
        (Array.isArray(payload?.data?.popupFormConfig) && payload.data.popupFormConfig) ||
        (Array.isArray(payload?.data?.data) && payload.data.data) ||
        (Array.isArray(payload?.data) && payload.data) ||
        (Array.isArray(payload?.popupFormConfigData) && payload.popupFormConfigData) ||
        (Array.isArray(payload?.popupFormConfig) && payload.popupFormConfig) ||
        []
      return { ...state, list: normalized, loading: false, error: null }
    }
    case "POPUP_FORM_ERROR":
      return { ...state, error: action.payload, loading: false }
    default:
      return state
  }
}

export default popupFormReducer
